import { render } from "./SalesCockpit.vue?vue&type=template&id=2d374e70"
import script from "./SalesCockpit.vue?vue&type=script&lang=js"
export * from "./SalesCockpit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__